import React, {useEffect} from 'react';
import {classes, style} from './doppe-viewer-action-popup-view.st.css';
import {flexColumn} from '@wix/devzai-utils-react';
import {
    useBymoPageViewerComponentsContext
} from '../../bymo-page-viewer-components-context/bymo-page-viewer-components-context';
import {IDoppeViewerActionContext} from '../../../doppe-sdk';

import {
    useWidgetRenderingContext
} from "../../doppe-viewer-widget-rendering-context/doppe-viewer-widget-rendering-context";

export const DoppeViewerActionPopupView = React.memo(function DoppeViewerActionPopupView(props: DoppeViewerActionPopupView.Props) {
    const {
        actionContext,
        className,
        ...htmlAttributes
    } = props;

    const action = actionContext.action;
    const actionType = actionContext.getActionType();


    const bymoPageViewerComponentsContextData = useBymoPageViewerComponentsContext();

    const widgetRenderingContext = useWidgetRenderingContext();

    useEffect(() => {
        // if this is not lock action
        if (!widgetRenderingContext?.lockController) {
            actionContext.reportActionImpression();
        }
    }, []);

    if (actionType.renderWidget === undefined) {
        return (
            <div>{`Action type with id '${action.actionTypeId}' doesn't support inline rendering.`}</div>
        )
    } else {
        return (
            <div
                {...htmlAttributes}
                className={style(classes.root, {}, flexColumn(), className)}
            >
                {
                    actionType.renderWidget({
                        actionContext: actionContext,
                    }, bymoPageViewerComponentsContextData.actionTypesViewerComponents.get(actionType.id))
                }
            </div>
        )
    }
});

export namespace DoppeViewerActionPopupView {


    export interface Props extends React.HTMLAttributes<any> {
        actionContext: IDoppeViewerActionContext<any>;
    }
}
